var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 970,
    viewBox: "0 0 720 970",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 720,
    height: 970
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 970,
    fill: "#256BF7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 970,
    fill: "#0041C2"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 570,
    cy: 669,
    r: 441,
    fill: "#256BF7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M669 85C669 406.982 407.982 668 86 668C-235.982 668 -497 406.982 -497 85C-497 -236.982 -235.982 -498 86 -498C407.982 -498 669 -236.982 669 85Z",
    fill: "#256BF7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 17.5,
    cy: 56.5,
    r: 291.5,
    fill: "#256BF7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 28.5,
    cy: 46.5,
    r: 188.5,
    fill: "#256BF7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.5,
    cy: 959.5,
    r: 182.5,
    fill: "#256BF7"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 68,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 92,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 116,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 44,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 92,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 116,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 44,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 68,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 116,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 44,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 68,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 92,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 854,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 878,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 902,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 926,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 854,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 878,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 902,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 926,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 854,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 878,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 902,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652,
    cy: 926,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 854,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 878,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 902,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 926,
    r: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/Bg.456a7190ccf2ab966588e630c4895854.svg";
export { ForwardRef as ReactComponent };